import * as React from 'react';

import Amazon from '@components/basics/streaming-logos/amazon';
import AmazonMusic from '@components/basics/streaming-logos/amazon-music';
import AppleMusic from '@components/basics/streaming-logos/apple';
import Spotify from '@components/basics/streaming-logos/spotify';
import Tidal from '@components/basics/streaming-logos/tidal';
import YouTube from '@components/basics/streaming-logos/youtube';
import YouTubeMusic from '@components/basics/streaming-logos/youtube-music';
import Soundcloud from '@components/basics/streaming-logos/soundcloud';
import Itunes from '@components/basics/streaming-logos/itunes';
import Google from '@components/basics/streaming-logos/google';
import GooglePlay from '@components/basics/streaming-logos/google-play';
import Pandora from '@components/basics/streaming-logos/pandora';
import Deezer from '@components/basics/streaming-logos/deezer';
import Napster from '@components/basics/streaming-logos/napster';
import Yandex from '@components/basics/streaming-logos/yandex';
import Spinrilla from '@components/basics/streaming-logos/spinrilla';

export const getStreamingServiceLogo = (streamingService: string) => {
  switch (streamingService) {
    case 'amazonStore':
      return <Amazon />;
    case 'amazonMusic':
      return <AmazonMusic />;
    case 'appleMusic':
      return <AppleMusic />;
    case 'itunes':
      return <Itunes />;
    case 'spotify':
      return <Spotify />;
    case 'tidal':
      return <Tidal className="small" />;
    case 'youtube':
      return <YouTube />;
    case 'youtubeMusic':
      return <YouTubeMusic />;
    case 'soundcloud':
      return <Soundcloud className="bigger" />;
    case 'google':
      return <Google />;
    case 'googleStore':
      return <GooglePlay />;
    case 'pandora':
      return <Pandora />;
    case 'deezer':
      return <Deezer />;
    case 'napster':
      return <Napster />;
    case 'yandex':
      return <Yandex />;
    case 'spinrilla':
      return <Spinrilla />;
    default:
      return '';
  }
};
